import { css } from 'vue-styled-components'

export const breakpointStyle = (breakpoint, content) => css`
  @media screen and (min-width: ${breakpoint}) {
    ${content}
  }
`



// WEBPACK FOOTER //
// ./src/utils/mixins.js